import { Breadcrumbs, Link as MuiLink } from '@mui/material'
import { Link } from 'react-router-dom'
import { EventsContext } from '../../views/Events/EventsProvider'
import { ReactNode, useContext } from 'react'

interface RootBreadcrumbProps {
  children?: ReactNode
}

function RootBreadcrumb({ children }: RootBreadcrumbProps) {
  const { getDailyEvents, setFilteredEvents, setSelectedFilter, filteredEvents, selectedFilter, searchedEvents } = useContext(EventsContext)

  const handleClick = () => {
    if (selectedFilter === 'search') {
      return setFilteredEvents(searchedEvents)
    }
    setFilteredEvents(filteredEvents)
    setSelectedFilter(selectedFilter)
    getDailyEvents()
  }

  return (
    <Breadcrumbs>
      <MuiLink component={Link} underline="always" color="inherit" to="/" onClick={handleClick} sx={{ display: 'flex', alignItems: 'center' }}>
        {'Hendelser'}
      </MuiLink>
      {children}
    </Breadcrumbs>
  )
}

export default RootBreadcrumb
